module.exports = __webpack_public_path__ + "static/media/Aesir4.256698a2.png";